import { createContext } from "react";

const HojaIndicacionContext = createContext();

export default HojaIndicacionContext;
